<div *ngIf='contactInfo' class='ContactActivity'>
  <div class='row py-2'>
    <div class='col col-12 col-md-6'>
      <app-button
        [Click]='emailContactButtonProperties.onClick'
        [color]='emailContactButtonProperties.color'
        [size]='emailContactButtonProperties.size'
        [text]='emailContactButtonProperties.text'></app-button>
    </div>
    <div class="col col-12 col-md-6">
      <div *ngIf="isContactDuplicate" class="alert alert-warning mb-0" role="alert">
        <strong>Warning!</strong> This contact is marked as a Known Duplicate.
      </div>
    </div>
  </div>
  <div class='ContactActivity-info row'>
    <div class='col col-12 col-md-6'>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <b>Contact Details</b>
        </div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>Company Name:</p>
        </div>
        <div class='col col-12 col-md-6'>{{ contactInfo.company }}</div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>Phone Number:</p>
        </div>
        <div class='col col-12 col-md-6'>{{ contactInfo.phone_number }}</div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>Email:</p>
        </div>
        <div class='col col-12 col-md-6'>{{ contactInfo.email }}</div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>Address-1:</p>
        </div>
        <div class='col col-12 col-md-6'>{{ contactInfo.address1 }}</div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>Address-2:</p>
        </div>
        <div class='col col-12 col-md-6'>{{ contactInfo.address2 }}</div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>City:</p>
        </div>
        <div class='col col-12 col-md-6'>{{ contactInfo.city }}</div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>State:</p>
        </div>
        <div class='col col-12 col-md-6'>{{ contactInfo.state }}</div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>Zip:</p>
        </div>
        <div class='col col-12 col-md-6'>{{ contactInfo.zip_code }}</div>
      </div>
    </div>
    <div class='col col-12 col-md-6'>
      <div class='row d-flex align-items-center'>
        <div class='col col-12 col-md-6'>
          <b>Current Status</b>
        </div>
        <div *ngIf='contactInfo.message_id' class='col col-12 col-md-6'>
          <app-button
            [Click]='viewConversationButtonProperties.onClick'
            [color]='viewConversationButtonProperties.color'
            [size]='viewConversationButtonProperties.size'
            [text]='viewConversationButtonProperties.text'></app-button>
        </div>
      </div>
      <div *ngIf='contactReplayAction' class='row'>
        <div class='col col-12 col-md-6'>
          <p>Current Reply Action:</p>
        </div>
        <div class='col col-12 col-md-6'>
          {{ contactInfo.contact_status }}
        </div>
      </div>
      <div
        *ngIf='!contactReplayAction && contactInfo.campaign_name'
        class='row'>
        <div class='col col-12 col-md-6'>
          <p>Campaign Name:</p>
        </div>
        <div class='col col-12 col-md-6'>
          {{ contactInfo.campaign_name }}
        </div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>Email Position:</p>
        </div>
        <div class='col col-12 col-md-6'>
          {{ contactInfo.email_position }}
        </div>
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6'>
          <p>Date Added:</p>
        </div>
        <div class='col col-12 col-md-6'>
          {{
            contactInfo.created_at
              | timezone: 'MM/DD/YYYY hh:mm a' : sessionData.time_zone
          }}
        </div>
      </div>
    </div>
  </div>
  <div class='ContactActivity-table'>
    <mat-radio-group
      (change)='changeActivitySource($event)'
      [value]='activityType'
      aria-label='Select an Activity source'
      class='ContactActivity-table-radio mb-3 mb-sm-0'>
      <mat-radio-button class='ContactActivity-table-radio-button' value='1'
      >New activity
      </mat-radio-button
      >
      <mat-radio-button class='ContactActivity-table-radio-button' value='2'
      >Legacy activity
      </mat-radio-button
      >
    </mat-radio-group>
    <div class='mt-3 mt-sm-0'>
      <app-table
        #tableComponent
        [columns]='tableColumns'
        [dataSourceParams]='dataSourceParams'
        [dataSource]='dataSource'>
        <ng-template [appTableMobileRow] let-currentUser='currentUser' let-row='row'>
          <app-contact-activity-mobile-row [activityType]='activityType' [contactInfo]='contactInfo'
                                           [currentUser]='currentUser'
                                           [item]='row'></app-contact-activity-mobile-row>
        </ng-template>
      </app-table>
    </div>
  </div>
</div>
